import { render, staticRenderFns } from "./createEditUser.vue?vue&type=template&id=0710c228&scoped=true&"
import script from "./createEditUser.vue?vue&type=script&lang=js&"
export * from "./createEditUser.vue?vue&type=script&lang=js&"
import style0 from "./createEditUser.vue?vue&type=style&index=0&id=0710c228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0710c228",
  null
  
)

export default component.exports